<script>
import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      isLoading:false,
    };
  },
  validations: {
    email: { required },
    password: { required }
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    }
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
console.log('ruta: '+process.env.VUE_APP_BACKEND);
      if (this.$v.$invalid) {
        return;
      } else {
        this.isLoading=true;
        this.axios.post(process.env.VUE_APP_BACKEND + '/users/authenticate', {
          email: this.email,
          password: this.password
        })
        .then(response => {
          //console.log(response);
          localStorage.setItem('user',JSON.stringify(response.data.user));
          localStorage.setItem('permissions',JSON.stringify(response.data.permissions));
          localStorage.setItem('jwt',response.data.token);
          localStorage.setItem('menu',JSON.stringify(response.data.menu));


          if (localStorage.getItem('jwt') != null){
            this.tryingToLogIn = false;
            this.isAuthError = false;
            this.$emit('loggedIn')
            if(this.$route.params.nextUrl != null){
              this.$router.push(this.$route.params.nextUrl)
            }
            else {
              this.$router.push('tablero')
            }
          }

        })
        .catch( ()=> {
          //console.error(error.response);
          this.isAuthError = true;
          this.authError = "Error en el usuario o contraseña...";
          //this.error=true;
        })
        .finally(()=>
        {
          this.isLoading=false;
        });

      }
    }
  }
};
</script>
<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-12">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Facultad de Ingenieria Civil y Arquiectura</h5>
                  <p>Iniciar sesion.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{authError}}</b-alert>

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >{{notification.message}}</div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group id="input-group-1" label="Usuario" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Ingrese usuario"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                  <span v-if="!$v.email.required">El correo es requerido.</span>
                </div>
              </b-form-group>

              <b-form-group id="input-group-2" label="Contraseña" label-for="input-2">
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Ingrese contraseña"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >Contraseña es requerida.</div>
              </b-form-group>
              <!--<div class="custom-control custom-checkbox">
                <input id="customControlInline" type="checkbox" class="custom-control-input" />
                <label class="custom-control-label" for="customControlInline">Recordar</label>
              </div>-->
              <div class="mt-3">
                <b-button type="submit" variant="primary" class="btn-block">
                  <b-spinner small v-show="isLoading"/>
                  Iniciar
                </b-button>
              </div>
              <!--<div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign in with</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>-->
              <!--<div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock mr-1"></i> ¿Te olvidaste tu contraseña?
                </router-link>
              </div>-->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
        <!--  <p>
            ¿No tienes cuenta?
            <router-link tag="a" to="/register" class="font-weight-medium text-primary">Registrarse ahora</router-link>
          </p>-->
          <p>
            © {{new Date().getFullYear()}} Etramite
            <i class="mdi mdi-access-point-network text-danger"></i> por FGlobal
          </p>        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
